export const PLACE_MENTIONS_PAGE_SIZE = 4
